var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTemplatesIcon = function SvgTemplatesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M.375 2A1.125 1.125 0 0 1 1.5.875h1.125A1.125 1.125 0 0 1 3.75 2v1.125A1.125 1.125 0 0 1 2.625 4.25H1.5A1.125 1.125 0 0 1 .375 3.125zm0 4.875A1.125 1.125 0 0 1 1.5 5.75h1.125A1.125 1.125 0 0 1 3.75 6.875V8a1.125 1.125 0 0 1-1.125 1.125H1.5A1.125 1.125 0 0 1 .375 8zM5.25 2A1.125 1.125 0 0 1 6.375.875H7.5A1.125 1.125 0 0 1 8.625 2v1.125A1.125 1.125 0 0 1 7.5 4.25H6.375A1.125 1.125 0 0 1 5.25 3.125zm0 4.875A1.125 1.125 0 0 1 6.375 5.75H7.5a1.125 1.125 0 0 1 1.125 1.125V8A1.125 1.125 0 0 1 7.5 9.125H6.375A1.125 1.125 0 0 1 5.25 8z"
  })));
};
export default SvgTemplatesIcon;